import React from "react";
import { useRecoilValue } from "recoil";
import { LocaleSelector } from "store/data/Base";
import styled from "styled-components";
import LoadingSVG from "assets/img/loading.gif";
import { getStyle, H00, MAIN_DEEP_WHITE } from "constants/colors";

interface LoadingProps {
  size?: "normal" | "big";
  height?: string; // 定制高度 优先级最高
  withoutTheme?: boolean;
  isShowText?: boolean;
}

const LoadingWrapper = styled.div<LoadingProps>`
  width: 100%;
  height: ${(props) => {
    if (props.height) {
      return props.height;
    }
    return props.size === "normal" ? "100%" : "100vh";
  }};
  min-height: ${(props) => {
    if (props.height) {
      return props.height;
    }
    return props.size === "normal" ? "300px" : "calc(100vh - 450px)";
  }};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: ${(props) =>
    props.withoutTheme ? MAIN_DEEP_WHITE : getStyle(H00.slice().reverse())};
  img {
    display: inline-block;
    width: 50px;
    height: 50px;
  }

  p {
    margin-top: 20px;
    font-size: 20px;
    color: #6f6f6f;
  }
`;

const Loading: React.FC<LoadingProps> = ({
  size,
  height,
  withoutTheme = false,
  isShowText = false,
}) => {
  const currentLocale = useRecoilValue(LocaleSelector);
  const text = {
    en: "Almost there! Unlock fast and easy trading for 270+ cryptocurrencies.",
    tr: "Az kaldı! 270+ kripto parayla hızlı ve kolay bir şekilde alım satım yapın.",
  };
  return (
    <LoadingWrapper
      height={height}
      size={size}
      className="loading"
      withoutTheme={withoutTheme}
    >
      <img src={LoadingSVG} alt={""} />
      {isShowText && <p>{text[currentLocale]}</p>}
    </LoadingWrapper>
  );
};

export default Loading;
